import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about-section">
      <p className="about-eyebrow">About TechAimz</p>
      <h2 className="about-heading">Intelligent systems for the public sector.</h2>
      <p className="about-description">
        TechAimz is a boutique software studio that builds intelligent systems for Government and Public Institutions. We blend AI, automation, and secure modern engineering to take the busywork off people's plates, so the public sector runs leaner, moves faster, and delivers better services to the communities who count on it.
      </p>
    </section>
  );
};

export default About;